import React, { Component } from "react";
import { Grid, Row, Col, Table, FormGroup } from "react-bootstrap";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import Card from "components/Card/Card.jsx";
import { WEB_URL } from "variables/Variables.jsx";
import Datetime from "react-datetime";
import moment from "moment";
import { ExportToCsv } from 'export-to-csv';
import Button from "components/CustomButton/CustomButton.jsx";
import h337 from "heatmapjs";
import Iframe from "components/Iframe.jsx"
import colorScale from "assets/img/heatmap_color_scale.png";

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

class HeatMap extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      heatMapList : null,
      dateStart: moment().subtract(1, 'months'),
      dateEnd: moment(),
      runningSearch : false,
      runningDeleteHeatMap : false,
      runningDeleteAllHeatMaps : false,
      IFrameSrc : 'about:blank',
      heatMapWidth : '666px',
      pageNumber : 1,
      fetchingPageNumber : 1,
      colorScaleIllustration : colorScale,
      analyticsDisabled : false
    }
  }

  componentDidMount () {
    this.fetchHeatMaps(1);
  }

  setDateStart(d){
    this.setState({dateStart : d});
  }

  setDateEnd(d){
    this.setState({dateEnd : d});
  }  

  fetchHeatMaps(fetchPage,action){
    var _this = this;  
    this.setState({runningSearch : true, fetchingPageNumber : fetchPage});

    if(document.querySelector('#heatMapPreviewFrame')) { // hide the page until heatmap loaded
      _this.setState({IframeSrc : 'about:blank'});
      document.querySelector('#heatMapPreviewFrame').onload = null;
      document.querySelector('#heatMapPreviewFrame').onload = function(){
        document.querySelector('#heatMapPreviewFrame').style['display'] = '';
      }
      document.querySelector('#heatMapPreviewFrame').style['display'] = 'none';
    }

    if(document.querySelector('.heatmap-canvas')){
      document.querySelector('.heatmap-canvas').style['visibility'] = 'hidden';
    }

    try{
    fetch("https://"+WEB_URL+"/account/api/getheatmapdata",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        'body' : JSON.stringify({'token':this.props.authDetail.token, 'identifier' : this.props.match.params.publication, 'pageNumber' : fetchPage, 'action' : action, 'trackId' : this.props.match.params.identifier })
      }).then(res => res.json())
        .then(
          (response) => {
            if(response.result == 'SUCCESS'){
              // load the proportions
              var img = new Image();
              img.onload = function(){
                  var dxdy = this.width/this.height;
                  var gradientOverlay = '';

                  // ask viewer for gradient overlay if we're rendering a reflowable pub 
                  // format: 
                  // total(height), total(height-1+height)
                  // "100(10)-60(15)-60(40)-50(60)-0(100)"
                  if(response.Reflowable){
                    dxdy = 700/1000;
                    var maxVal = response.ScrollMaxValue;
                    var scrollTotHeight = response.ScrollTotHeight;
                    var currentLevel = 0;
                    var scrollData = response.Scroll.slice();

                    var moveToZero = [];
                    
                    for(var si=0;si<scrollData.length;si++){
                        if(scrollData[si].y==null||scrollData[si].y<0){
                            moveToZero.push(scrollData.splice(si,1)[0]);
                            si--;
                        }
                    }

                    for(var mi=0;mi<moveToZero.length;mi++){
                      scrollData[0].height += moveToZero[mi].height;
                      scrollData[0].value += moveToZero[mi].value;

                      if(scrollData[0].value > maxVal){
                        scrollData[0].value = maxVal;
                      }
                    }

                    for(var si=0;si<scrollData.length;si++){
                        var newLevel = Math.round(scrollData[si].height/scrollTotHeight*100);
                        gradientOverlay += Math.round(scrollData[si].value/maxVal*100)+'('+(currentLevel+newLevel)+')-';
                        currentLevel += newLevel;
                    }
                    
                    if(gradientOverlay.length){
                        gradientOverlay = gradientOverlay.substr(0,gradientOverlay.length-1);
                    }else{
                        gradientOverlay = true;
                    }
                  }

                  _this.setState({IframeSrc : _this.getCloudLink(true,Math.round(1000*dxdy) + 'px',fetchPage,gradientOverlay)});
                  _this.setState({heatMapWidth : (1000*dxdy) + 'px'});
                  _this.setState({analyticsDisabled : false});
                  
                  var exCanvas = document.querySelector('.heatmap-canvas');
                  if(exCanvas){exCanvas.parentNode.removeChild(exCanvas)}

                  if(!response.Reflowable){
                      _this.heatmapInstance = h337.create({
                          // only container is required, the rest will be defaults
                          container: document.querySelector('.heatmap')
                      });
                  
                      // TEST DATA
                      //var points = [{"pageNumber":1,"x":248,"y":274,"value":12,"radius":248},{"pageNumber":1,"x":284,"y":273,"value":12,"radius":284},{"pageNumber":1,"x":348,"y":275,"value":12,"radius":299},{"pageNumber":1,"x":435,"y":289,"value":12,"radius":231},{"pageNumber":1,"x":456,"y":447,"value":12,"radius":211},{"pageNumber":1,"x":458,"y":611,"value":12,"radius":208},{"pageNumber":1,"x":442,"y":765,"value":12,"radius":224},{"pageNumber":1,"x":435,"y":815,"value":12,"radius":232},{"pageNumber":1,"x":368,"y":819,"value":12,"radius":298},{"pageNumber":1,"x":279,"y":815,"value":54.598150033144236,"radius":279},{"pageNumber":1,"x":279,"y":815,"value":12,"radius":279},{"pageNumber":1,"x":279,"y":302,"value":12,"radius":279},{"pageNumber":1,"x":293,"y":271,"value":12,"radius":293},{"pageNumber":1,"x":283,"y":259,"value":13,"radius":277},{"pageNumber":1,"x":264,"y":198,"value":13,"radius":162},{"pageNumber":1,"x":262,"y":223,"value":14,"radius":162},{"pageNumber":1,"x":332,"y":234,"value":14,"radius":162},{"pageNumber":1,"x":332,"y":234,"value":54.598150033144236,"radius":162},{"pageNumber":1,"x":267,"y":306,"value":14,"radius":267},{"pageNumber":1,"x":279,"y":239,"value":15,"radius":279},{"pageNumber":1,"x":340,"y":240,"value":15,"radius":299},{"pageNumber":1,"x":340,"y":240,"value":15,"radius":299},{"pageNumber":1,"x":389,"y":751,"value":15,"radius":278},{"pageNumber":1,"x":403,"y":778,"value":15,"radius":264},{"pageNumber":1,"x":463,"y":879,"value":16,"radius":146},{"pageNumber":1,"x":468,"y":897,"value":17,"radius":115},{"pageNumber":1,"x":474,"y":913,"value":18,"radius":82},{"pageNumber":1,"x":458,"y":909,"value":18,"radius":82},{"pageNumber":1,"x":458,"y":909,"value":54.598150033144236,"radius":82},{"pageNumber":1,"x":404,"y":749,"value":19,"radius":263},{"pageNumber":1,"x":419,"y":657,"value":19,"radius":247},{"pageNumber":1,"x":435,"y":544,"value":19,"radius":232},{"pageNumber":1,"x":436,"y":405,"value":19,"radius":231}]
                  
                      var max = response.MaxValue;
                      var width = 840;
                      var height = 400;
                  
                      // heatmap data format
                      _this.heatMapData = {
                          max: max,
                          data: response.Engagement
                      };
                  
                      _this.setState({runningSearch : false,pageNumber : fetchPage, analyticsDisabled : false});
                      _this.heatmapInstance.setData(_this.heatMapData);
                      document.querySelector('.heatmap-canvas').style['visibility'] = 'visible';
                      document.querySelector('.heatmap-disabled').style['display'] = 'none';
                      document.querySelector('.heatmap').style['display'] = 'block';
                  }else{
                    _this.setState({runningSearch : false,pageNumber : fetchPage});
                  }
              }
              img.src = response.ModelImage;
            }else{
              _this.setState({runningSearch : false,pageNumber : fetchPage, analyticsDisabled : true});
              document.querySelector('.heatmap-disabled').style['display'] = 'block';
              document.querySelector('.heatmap').style['display'] = 'none';
            }
          },
          (error) => {
            _this.setState({runningSearch : false});

          }
        )
      }catch(e){
        _this.setState({runningSearch : false}); 
      }
  }

  deleteAllHeatMaps(){
    var _this = this;

    if(window.confirm('Are you sure you want to clear all heat map data for this publication?')){
        this.setState({runningDeleteAllHeatMaps : true});

        fetch("https://"+WEB_URL+"/account/api/getheatmapdata",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        'body' : JSON.stringify({'token':this.props.authDetail.token, 'identifier' : this.props.match.params.publication, 'pageNumber' : this.state.pageNumber, 'action' : 'DELETE'})
      }).then(res => res.json())
        .then(
          (response) => {
            var exCanvas = document.querySelector('.heatmap-canvas');
            if(exCanvas){exCanvas.parentNode.removeChild(exCanvas)}
            _this.setState({runningDeleteAllHeatMaps : false});
          },
          (error) => {
            _this.setState({runningDeleteAllHeatMaps : false});

          }
        )
    }  
  }

  getCloudLink(printMode,printWidth,fetchPage,gradientOverlay){
    if(!gradientOverlay){
        return "https://"+this.props.authDetail.user+".flowpaper.com/"+this.props.match.params.publication+"/"+(printMode?"index.html?"+(new Date().getTime())+"#DisplayRange="+fetchPage+",DisableOverflow=true,DisablePrint=true,PrintWidth="+printWidth:"");
    }else{
        return "https://"+this.props.authDetail.user+".flowpaper.com/"+this.props.match.params.publication+"/"+(printMode?"index.html?"+(new Date().getTime())+"#section="+(fetchPage-1)+",GradientOverlay="+gradientOverlay:"");
    }
  }

  getCloudLinkDetail(publication){
    if(this.props.authDetail.detail.cloudId){
      return "https://"+this.props.authDetail.detail.cloudId+".flowpaper.com/"+publication+"/";
    }else{
      return "https://online.flowpaper.com/"+this.props.authDetail.user+"/"+publication+"/";
    }
  }

  goBack(){
    if(this.props.match.params.identifier && this.props.match.params.identifier.length > 1){
      this.props.history.push('/home/trackablelinks/'+this.props.match.params.publication); 
    }else{
      this.props.history.push('/home/cloud/'); 
    }
  }

  prevPage(){
    if(this.state.pageNumber>1){
        this.fetchHeatMaps(this.state.pageNumber-1);
    }
  }

  nextPage(){
    this.fetchHeatMaps(this.state.pageNumber+1);
  }

  onPageKeyDown(e){
    if(e.keyCode==13){
      this.fetchHeatMaps(this.state.pageNumber);
    }
    return true;
  }

  onEnableAnalytics(){
    this.fetchHeatMaps(this.state.pageNumber,'ENABLE');
  }

  onDisableAnalytics(){
    this.fetchHeatMaps(this.state.pageNumber,'DISABLE');
  }

  render() {
    return (
      <div className="content" style={{'min-height':'1300px'}}>
        <Grid fluid>
          <Row>
            <Col md={10}>
              { (window.location.href.indexOf('?route=dtp')==-1?<ProgressButton bsStyle="default btn-wd btn btn-sm" fill type="submit" onClick={(e) => {this.goBack(e);}}><i class="pe-7s-back"></i> Go Back</ProgressButton>:'')}
            </Col>
          </Row>
          { (window.location.href.indexOf('?route=dtp')==-1?
          <Row>
            <Col md={10}>
            <h4 style={{'margin-top':20}}><b>Publication</b>: <a target="_new" href={this.getCloudLink()}>{this.getCloudLinkDetail(this.props.match.params.publication)}</a></h4>
            </Col>
          </Row>
          :'')}
          <Row>
            <Col style={{width:this.state.heatMapWidth}}>
              <p style={{'margin-left':16,'font-size':12}}>Note that the data below is from the current and previous year</p>
            </Col>
          </Row>
          <Row>
            {/* <Col md={2}>
              <FormGroup>
                <label class="control-label">Date From</label>
                <Datetime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  inputProps={{ placeholder: "Datetime Picker Here" }}
                  defaultValue={this.state.dateStart}
                  onChange={(d) => this.setDateStart(d)}
                />
               </FormGroup>
             </Col>
             <Col md={2}>
              <FormGroup>
                <label class="control-label">Date To</label>
                <Datetime
                  timeFormat={false}
                  dateFormat="DD/MM/YYYY"
                  inputProps={{ placeholder: "Datetime Picker Here" }}
                  defaultValue={this.state.dateEnd}
                  onChange={(d) => this.setDateEnd(d)}
                />
               </FormGroup>
             </Col>       */}
             <Col style={{width:this.state.heatMapWidth}}>
              <FormGroup>
                <label style={{visibility:'hidden',display:'block'}} class="control-label">---</label>
                {/* <ProgressButton runningAsyncOperation={this.state.runningSearch} bsStyle="info" fill type="submit" onClick={(e) => {this.fetchHeatMaps(e);}}>
                    Search
                </ProgressButton> */}
                <ProgressButton runningAsyncOperation={this.state.runningSearch} bsStyle="info btn-xs" fill type="submit" style={{'margin-left':'10px','min-width':'90px','min-height':'28px'}} onClick={(e) => {this.prevPage(e);}}>
                    <i class="pe-7s-angle-left"></i> Prev Page
                </ProgressButton>
                <ProgressButton runningAsyncOperation={this.state.runningSearch} bsStyle="info btn-xs" fill type="submit" style={{'margin-left':'10px','min-width':'90px','min-height':'28px'}} onClick={(e) => {this.nextPage(e);}}>
                    Next Page <i class="pe-7s-angle-right"></i>
                </ProgressButton>
                {(this.state.analyticsDisabled && this.props.authDetail.detail.hascreative?<Button bsStyle="info pull-right btn-xs" style={{'min-height':'28px'}} fill type="submit" onClick={(e) => {this.onEnableAnalytics(e);}}>
                    Enable Heatmap Analytics
                </Button>:'')}
                {(!this.state.analyticsDisabled && this.props.authDetail.detail.hascreative?<Button bsStyle="warning pull-right btn-xs" style={{'min-height':'28px'}} fill type="submit"  onClick={(e) => {this.onDisableAnalytics(e);}}>
                    Disable Heatmap Analytics
                </Button>:'')}
                <span style={{'margin-left':'100px'}}>Page:</span>
                <input type="text" class="form-control" style={{'width': '100px','display': 'inline','height': '30px','vertical-align': 'middle','margin-left': '10px'}} onChange={(e) => {this.setState({pageNumber: e.target.value})}} value={this.state.pageNumber} onKeyDown={(e) => {this.onPageKeyDown(e);}} />

              </FormGroup>
             </Col>       
          </Row>
          <Row>
            <Col md={8}>
                <div class="heatmap" style={{position:'absolute','z-index':2,left:0,top:0,width:this.state.heatMapWidth,height:'1000px','box-shadow':'0 1px 2px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(63, 63, 68, 0.1)'}}>
                    <Iframe id="heatMapPreviewFrame" src={this.state.IframeSrc} style={{position:'relative',left:0,top:0,width:this.state.heatMapWidth,height:'1000px','z-index':1,opacity:0.5,background:'#ffffff'}}/>,
                </div>
                <div class="heatmap-disabled" style={{display:'none',position:'absolute','z-index':2,left:0,top:0,width:this.state.heatMapWidth,height:'1000px','box-shadow':'0 1px 2px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(63, 63, 68, 0.1)'}}>
                    <div style={{'padding':'5%'}}><h3>Heatmap data not available</h3>  Heatmap analytics has not been enabled for this publication. Click on "Enable Heatmap Analytics" to start collecting data.</div>
                </div>
            </Col>
            {(window.location.href.indexOf('?route=dtp')>-1?
            <div style={{'position':'fixed','top':'150px','right':'20px'}}>
              <span style={{float:'left',clear:'both','font-size':'12px','text-align':'center'}}>High Activity</span>
              <img src={colorScale} style={{'margin-left':'25px','clear':'both','float':'left'}} />
              <span style={{float:'left',clear:'both','font-size':'12px','text-align':'center'}}>Low Activity</span>
            </div>:'')}
            {(window.location.href.indexOf('?route=dtp')==-1?
              <Col sm={1}>
              <span style={{float:'left',clear:'both','font-size':'12px','text-align':'center'}}>High Activity</span>
              <img src={colorScale} style={{'margin-left':'14px','clear':'both','float':'left'}} />
              <span style={{float:'left',clear:'both','font-size':'12px','text-align':'center'}}>Low Activity</span>
              </Col>:'')}
          </Row>
        </Grid>
      </div>
    );
  }
}

export default HeatMap;

